import * as t from 'io-ts';
import { DateTime } from './customTypes/dateTime';

export const AccountNotificationDynamicType = t.interface({
    id: t.string,
    hasBeenRead: t.boolean,
    message: t.string,
    bookingId: t.string,
    enquiryNumber: t.number,
    route: t.union([t.string, t.null]),
    flightDate: t.union([DateTime, t.null]),
    createdAt: DateTime
});

export type AccountNotification = t.TypeOf<typeof AccountNotificationDynamicType>;
